import md5 from 'blueimp-md5/js/md5.min.js'
riot.tag2('auth', '  <div class="layout"></div>\n  <div class="container">\n    <div class="row">\n      <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4">\n        <div class="auth-logo"></div>\n        <form onsubmit="{auth}">\n          <div class="panel panel-default" style="margin-top: 30px;">\n            <div class="panel-heading text-center">\n              <div class="panel-title">Авторизация</div>\n            </div>\n            <div class="panel-body">\n              <div class="alert alert-danger" if="{error}"><a class="close" href="#" onclick="{closeErrorAlert}">&times;</a>Неправильный или неактивный логин или пароль!</div>\n              <div class="form-group">\n                <div class="input-group"><span class="input-group-addon">\n                    <div class="fa fa-user fa-fw"></div></span>\n                  <input class="form-control" name="serial" placeholder="Логин">\n                </div>\n              </div>\n              <div class="form-group">\n                <div class="input-group"><span class="input-group-addon">\n                    <div class="fa fa-key fa-fw"></div></span>\n                  <input class="form-control" name="password" placeholder="Пароль" type="password">\n                </div>\n              </div>\n              <div class="form-group" style="margin-bottom: 0;">\n                <div class="checkbox">\n                  <label>\n                    <input name="remember" type="checkbox">Запомнить меня\n                  </label>\n                </div>\n              </div>\n            </div>\n            <div class="panel-footer text-center">\n              <input class="btn btn-success" type="submit" value="Продолжить">\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n', 'auth .layout,[riot-tag="auth"] .layout,[data-is="auth"] .layout{ position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: #c7c7c7; z-index: -1; }', '', function(opts) {
'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.closeErrorAlert = function () {
    self.error = false;
};

self.auth = function () {

    app.login({
        serial: self.serial.value.trim(),
        password: md5(self.password.value.trim()),
        success: function success(response, secookie) {
            var mainUser = {
                login: self.serial.value.trim(),
                hash: md5(self.password.value.trim()),
                project: response.project
            };

            localStorage.setItem('shop24_main_user', (0, _stringify2.default)(mainUser));

            if (self.remember.checked) localStorage.setItem('shop24_user', (0, _stringify2.default)(response.config));

            if (response.permissions) localStorage.setItem('shop24_permissions', (0, _stringify2.default)(response.permissions));

            localStorage.setItem('shop24_cookie', secookie);
            localStorage.setItem('shop24', (0, _stringify2.default)(response.config));
            app.init();
        },
        error: function error(response) {
            self.error = true;
            self.update();
        }
    });
};
});


// WEBPACK FOOTER //
// ./pages/auth.tag